import { motion } from "framer-motion";

export default function LiveTicker() {
  const items = [
    "Now accepting new projects",
    "Free brand consultation",
    "Response within 48h",
  ];

  return (
    <motion.div
      data-testid="live-ticker"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className="inline-flex items-center gap-3 glass rounded-full pl-3 pr-4 py-2"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-gk-gold opacity-70 animate-ping" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-gk-gold" />
      </span>
      <div className="flex items-center gap-2 font-inter text-[11px] md:text-xs text-white/70">
        {items.map((t, i) => (
          <span key={i} className="flex items-center gap-2 whitespace-nowrap">
            <span className={i === 0 ? "text-gk-champagne" : ""}>{t}</span>
            {i < items.length - 1 && <span className="text-gk-gold/40">·</span>}
          </span>
        ))}
      </div>
    </motion.div>
  );
}
